function a(n) {
  return { name: "VBScript in HTML", subLanguage: "xml", contains: [{ begin: "<%", end: "%>", subLanguage: "vbscript" }] };
}
export {
  a as default
};
